// extracted by mini-css-extract-plugin
module.exports = {"row":"w77oz","rowSecond":"aJAee"};